import "../styles/Dashboard.css";
import { Link } from "react-router-dom";
import astrologyImg from "../images/astrology.png";
import weatherImg from "../images/weather.png";
import newsImg from "../images/news.png";

function Dashboard() {
  return (
    <>
      <h1 className="mt-4">Choose your theme</h1>
      <div className="card-group  mt-5">
        <div className="card mb-3" style={{ maxWidth: "18rem" }}>
          <img className="card-img-top" src={astrologyImg} alt="astrology" />
          <div className="card-body">
            <h5 className="card-title">Astrology</h5>
            <p className="card-text">Daily horoscope !</p>
            <Link to="/astrology" className="btn btn-primary">
              More information
            </Link>
          </div>
        </div>
        <div className="card mb-3" style={{ maxWidth: "18rem" }}>
          <img className="card-img-top" src={weatherImg} alt="weather" />
          <div className="card-body">
            <h5 className="card-title">Weather</h5>
            <p className="card-text">Weather of the day !</p>
            <Link to="/weather" className="btn btn-primary">
              More information
            </Link>
          </div>
        </div>
        <div className="card mb-3" style={{ maxWidth: "18rem" }}>
          <img className="card-img-top" src={newsImg} alt="news" />
          <div className="card-body">
            <h5 className="card-title">News</h5>
            <p className="card-text">Search the news !</p>
            <Link to="/news" className="btn btn-primary">
              More information
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
